import { createRoute } from '@tanstack/react-router'

import { entityRoute } from '@/app/routes/entity-route'

export const adminRoute = createRoute({
  getParentRoute: () => entityRoute,
  id: 'admin',
})
